<template>
  <main id="container">
    <div class="title-section invisible-default">
      <h2
        v-if="this.$route.meta.navigation && this.$route.meta.navigation.title()"
        class="title"
      >
        {{ this.$route.meta.navigation.title() }}
      </h2>
      <h6
        v-if="this.$route.meta.navigation && this.$route.meta.navigation.subtitle"
        class="subtitle"
      >
        {{ this.$route.meta.navigation.subtitle() }}
      </h6>
    </div>

    <div class="columns">
      <div class="left-column bg-grey-bg lg:bg-white">
        <router-view />
      </div>
      <div class="right-column hidden lg:block" v-if="showSidebar">
        <detail-forfait/>
      </div>
    </div>
  </main>
</template>

<script>
    import DetailForfait from "../components/layout/detail-forfait";
    import { routesWithoutSidebar } from "@/helpers/routesHelpers";
    import { mapGetters } from "vuex";

    export default {
      name: "home",
      components: { DetailForfait },
      computed: {
        ...mapGetters("device", ["size"]),
        showSidebar: function() {
          if (this.size === 'sm') return false;
          return !routesWithoutSidebar.includes(this.$route.name);
        },
      },
    };
</script>

<style scoped>

  #container {
    @apply pt-12;
  }

  .left-column {
    @apply w-full bg-white flex flex-col pt-0 pl-0 text-left;
  }

  .right-column {
    @apply w-full relative invisible;
  }

  @screen lg {
    #container {
      width: 956px;
      @apply pt-0;
    }

    .left-column {
      @apply w-3/5;
    }

    .right-column {
      @apply w-2/5 bg-white ml-5 visible;
    }

    .columns {
      @apply flex items-start mb-48
    }

    .title-section {
      @apply w-full mb-4;
    }

    .title {
      @apply w-full pb-0;
    }

    .subtitle {
      @apply w-full mb-0 text-grey-subtitle;
    }

  }
</style>
